module.exports = __webpack_public_path__ + "img/sm-164968106540620220408071544.4b541889.jpg";